import markdownContent from '!!raw-loader!static/privacy.md';
import { Markdown } from 'Common';

export const ExternalPrivacyPolicyPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};

export default ExternalPrivacyPolicyPage;
